import React from 'react'
import SimplifiedTranscribeModal from './components/SimplifiedTranscribeModal'

const TranscribeAi = ({
  setNoteState,
  modalOpen,
  setModalOpen,
  noteState,
  debouncedNoteCapture,
  userRef,
  bookingData,
  websocketConnection,
  onRefresh
}) => {
  return (
    <SimplifiedTranscribeModal
      visible={modalOpen}
      onCancel={() => setModalOpen(false)}
      setNoteState={setNoteState}
      noteState={noteState}
      debouncedNoteCapture={debouncedNoteCapture}
      userRef={userRef}
      bookingData={bookingData}
      websocketConnection={websocketConnection}
      onRefresh={onRefresh}
    />
  )
}

export default TranscribeAi
